module.exports = __webpack_public_path__ + "static/media/Print-icon.4d41fec5.svg";